<template>
  <div>
    <div v-if="profile.userApproval.status === 0" class="flex justify-center w-full text-red text-xl">
      <i class="fas fa-info-circle mr-2 mt-2 mb-2"></i><span>This Profile is currently being reviewed by our Marketing department. Please await feedback. <br>For any queries, please email <a :href="`mailto:marketing@fineandcountry.com`" class="no-underline hover:underline text-red">marketing@fineandcountry.com</a></span>
    </div>
    <div v-if="profile.userApproval.status === 4" class="flex justify-center w-full text-red text-xl">
      <i class="fas fa-info-circle mr-2"></i><span>Marketing has reviewed and updated your information please check and approve the amends</span>
    </div>
        <div v-if="profile.userApproval.status === 3 && !profile.approved" class="flex justify-center w-full text-red text-xl">
      <i class="fas fa-info-circle mr-2"></i><span>Note: This Profile has not yet been submitted for approval and is currently only a saved draft</span>
    </div>
    <div v-if="profile.userApproval.status === 2" class="flex justify-center w-full text-red text-xl">
      <i class="fas fa-info-circle mr-2"></i><span>Your profile review has been rejected please check the comments and resubmit for approval</span>
    </div>
    <div class="flex flex-wrap -mx-2 text-sm items-stretch border-bottom mb-4">
      <!-- LEFT SIDE: Personal Details -->
      <div class="flex-1 w-full lg:w-1/2 px-4">
        <h1 slot="header" class="w-full text-lg py-4">
          Personal Details:
        </h1>
        <h2 class="text-grey-dark text-sm font-medium leading-normal pb-4 ">
          These will be your personal details and contact information used for all web and print assets
        </h2>

        <personal-details v-model="profile" :errorBag="errorBag" :network="network"></personal-details>

        <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" >Assigned Offices:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">These are offices where you can view and alter data</span>
              </div>
            </i>
            <div class="py-3 font-bold">
              <div v-for="(AssociateOfficeName, index) in assignedOffices" :key="AssociateOfficeName.id">
                <p @click="openOffice(AssociateOfficeName)" class="py-1 font-bold text-blue cursor-pointer">{{AssociateOfficeName.name}}<span v-if="index+1 < assignedOffices.length">, </span></p>
              </div>
            </div>
          </div>

          <div v-if="system.external_data.bios === true" class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" >Visible on Meet The Team page:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">These are offices where you appear on the Meet The Team page</span>
              </div>
            </i>
          <p v-if="profile.type == 0 || profile_v2.type == 1" class="py-3 font-bold">For admin there is no need for associated office</p>
            <div v-else class="flex flex-col">
              <div v-for="(AssociateOfficeName, index) in profile_v2.associated_office_name" :key="AssociateOfficeName">
               <p class="mb-1 py-1 font-bold">{{AssociateOfficeName}}<span v-if="index+1 < profile_v2.associated_office_name.length">, </span></p>
              </div>
            </div>
          </div>

        </div>
          <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
            <div class="w-full lg:w-1/2 px-2 mb-4">
              <label class="mr-1">Access to:</label><i class="tooltip-container fas fa-info-circle text-blue">
                <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                  <span class="text-black font-sans">These are the services you have access to directly from the {{system.title}}</span>
                </div>
              </i>
              <div class="flex">
                <p v-if="profile.referral_system && system.external_data.systems_available.includes('referrals')" class="py-3 font-bold mr-2">Referral System </p>
                <p v-if="profile.knowledge_hub && system.external_data.systems_available.includes('knowledge-hub')" class="py-3 font-bold">Knowledge Hub</p>
              </div>
            </div>
        </div>
      </div>
      <!-- RIGHT SIDE: Profile Picture -->
      <profile-image v-model="profile" @mediaupdate="mediaUpdate()" ></profile-image>
    </div>
    <social-media v-model="profile"></social-media>
    <social-accounts class="border-bottom mb-4 rounded-none" />
    <profile-biography v-if="system.external_data.bios === true" v-model="profile"> </profile-biography>
    <approval v-model="profile" @submitSave="saveProfile(profile)" @approveAmends="approveAmends()" @submitApproval="submitApproval()" @cancelApproval="cancelApproval()" @revertChanges="revertChange()" @open-comment-model="showCommentModal = true"></approval>
    <profile-comment
      v-if="showCommentModal"
      :scrollY="true"
      @dismissed="showCommentModal = false"
      @leave="showCommentModal = false"
      :showCloseBtn="true"
      :user="profile"
    >
    </profile-comment>
     <modal
      v-if="openOfficeModal"
      :scrollY="false"
      @dismissed="checkChanges()"
      @leave="checkChanges()"
      :showCloseBtn="true"
      :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/4'"
    >
      <div class="flex h-full flex-col items-center">
       <office ref="officemodal" @close="closeOfficeModal()" v-if="office" :office="office" :isExpanded="true" />
      </div>
    </modal>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import VueAvatar from './VueAvatar.vue'
import SocialAccounts from '@/components/SocialAccounts'
import Approval from './Approval'
import PersonalDetails from './PersonalDetails.vue'
import SocialMedia from './SocialMedia.vue'
import ProfileImage from './ProfileImage.vue'
import ErrorBag from '@/ErrorBag'
import ProfileBiography from './ProfileBiography.vue'
import ProfileComment from './ProfileComment.vue'
import api from '@/http'
import _ from 'lodash'
import Office from '@/components/Office.vue'
export default {
  name: 'profileAccount',
  components: {
    VueAvatar,
    SocialAccounts,
    PersonalDetails,
    SocialMedia,
    ProfileImage,
    ProfileBiography,
    Approval,
    ProfileComment,
    Office
  },
  computed: {
    ...mapState(['profile_v2', 'system', 'selectedOffice', 'userOfficeList']),
    assignedOffices () {
      let tempOffice = this.userOfficeList
      tempOffice = tempOffice.filter(office => {
        return office.client_id === this.selectedOffice.client_id
      })
      return tempOffice
    }
  },
  created () {
    this.profile = this.profile_v2
    this.initialProfile = JSON.parse(JSON.stringify(this.profile_v2))
  },
  data () {
    return {
      profile: null,
      errorBag: new ErrorBag(),
      saveDisabled: false,
      showCommentModal: null,
      initialProfile: null,
      buttonPress: false,
      openOfficeModal: false,
      modalOffice: false,
      office: null
    }
  },
  props: ['network'],
  methods: {
    ...mapActions([
      'updateProfileV2',
      'updateProfilePicV2',
      'fetchProfileV2',
      'displayToastNotification'
    ]),
    prepareToExit (to, from, next) {
      if (!this.buttonPress && !_.isEqual(this.initialProfile, JSON.parse(JSON.stringify(this.profile)))) {
        this.$emit('leaving')
        this.$emit('destination', to)
      } else {
        next()
      }
    },
    mediaUpdate () {
      // this.fetchProfileV2().then(response => {
      //   // this.profile.userApproval.uploaded_video = this.profile_v2
      // })
    },
    getOfficeList () {
      var params = {
        office_id: this.selectedOffice.id
      }
      api.get('/office-list', { params }).then(response => {
        this.office_list = response.data
      }).catch(({ response }) => {
        if (response.status === 422) {
        }
      })
    },
    async saveProfile (val) {
      this.errorBag.clear()
      this.$emit('savingUser', true)
      this.saveDisabled = true
      await this.updateProfileV2(val).then(response => {
        this.$emit('savingUser', false)
        this.profile = this.profile_v2
        this.initialProfile = JSON.parse(JSON.stringify(this.profile_v2))
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Profile Updated',
          info: 'Your user has been updated successfully.'
        })
        this.saveDisabled = false
      }, error => {
        if (error.response.status === 422) {
          this.errorBag.store(error.response.data)
          this.$emit('savingUser', false)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Profile Update',
            info: 'Error saving profile.'
          })
          this.saveDisabled = false
        }
      })
    },
    async submitApproval () {
      await this.saveProfile(this.profile)
      let params = {
        selectedOffice: this.selectedOffice.id
      }
      api.post('/submit-approval/' + this.profile.id, params).then(response => {
        this.profile = response.data
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Submit approval',
          info: 'Your have successfully submitted for approval.'
        })
      }, error => {
        if (error.response.status === 422) {
          this.errorBag.store(error.response.data)
          this.$emit('savingUser', false)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Failed Submission',
            info: 'Error submitting your profile'
          })
        }
      })
    },
    cancelApproval () {
      let params = {
        selectedOffice: this.selectedOffice.id
      }
      api.post('/cancel-approval/' + this.profile.id, params).then(response => {
        this.profile = response.data
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Cancel Approval',
          info: 'Your have successfully cancelled approval process.'
        })
      })
    },
    approveAmends () {
      let params = {
        selectedOffice: this.selectedOffice.id
      }
      api.post('/approve-amends/' + this.profile.id, params).then(response => {
        this.profile = response.data
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Approved amends',
          info: 'Your have successfully approved marketing changes'
        })
      })
    },
    revertChange () {
      let params = {
        selectedOffice: this.selectedOffice.id
      }
      api.patch('/revert-user/' + this.profile.id, params).then(response => {
        this.profile = response.data
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Changes reverted',
          info: 'Your changes has reverted'
        })
        this.revertModal = false
      })
    },
    openOffice (office) {
      this.office = office
      this.openOfficeModal = true
    },
    closeOfficeModal () {
      this.openOfficeModal = false
    },
    checkChanges () {
      var value = null
      value = this.$refs.officemodal.checkStatus()
      if (!value) {
        this.openOfficeModal = false
      }
    }
  }
}
</script>
